import { SessionContext } from "@/context/SessionContext";
import { Song } from "@/javascript/library-objects";
import { ActionIcon, Group, Table, Text } from "@mantine/core";
import { IconTrashXFilled } from "@tabler/icons-react";
import { useContext, useEffect, useState } from "react";


export function CartTable() {
	const session = useContext(SessionContext);
	if (session === undefined) {
		throw new Error("SongDetails must be a child of SessionContext.");
	}

	const [cartSongs, setCartSongs] = useState<Song[]>(session.songsInCart || [])
	const cartTotal = cartSongs.reduce((total, song) => total + (song.price || 0), 0).toFixed(2);

	useEffect(() => {
		setCartSongs(session.songsInCart || []);
	}, [session.songsInCart]);

	function handleCartRemove(songId: string) {
		const updatedCart = cartSongs.filter((song) => song.songId !== songId);
		setCartSongs(updatedCart);
		session?.setSongsInCart(updatedCart);
	}

	const rows = cartSongs.map((song) => (
		<Table.Tr key={song.songName}>
			<Table.Td>
				<Group gap="sm">
					<div>
						<Text fz="md" color={"blue.7"}>
							{song.songName}
						</Text>
					</div>
				</Group>
			</Table.Td>
			<Table.Td>
				<Text fz="md" color={"blue.7"}>{song.artists[0].artistName}</Text>
			</Table.Td>
			<Table.Td>
				<Text fz="md" color={"blue.7"}>${song.price?.toFixed(2)}</Text>
			</Table.Td>
			<Table.Td>
				<Group gap={0} justify="flex-end">
					<ActionIcon variant="subtle" color="#FF0000" onClick={() => handleCartRemove(song.songId)}>
						<IconTrashXFilled size={16} stroke={1.5} />
					</ActionIcon>
				</Group>
			</Table.Td>
		</Table.Tr>
	));

	const totalRow = (
		<Table.Tr bg={"blue.7"}>
			<Table.Td bg={"blue.6"} />
			<Table.Td>
				<Text fz="md" fw={"700"} color={"blue.0"}>Total</Text>
			</Table.Td>
			<Table.Td>
				<Text fz="md" fw={"700"} color={"blue.0"}>${cartTotal}</Text>
			</Table.Td>
			<Table.Td />
		</Table.Tr>
	);
	rows.push(totalRow)

	return (

		<Table.ScrollContainer w={"75%"} pt={100} minWidth={800}>
			<Table verticalSpacing="md">
				<Table.Tbody bg={"blue.0"}>{rows}</Table.Tbody>
			</Table>
		</Table.ScrollContainer>

	);

}

export default CartTable